import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "dispatch-device-datatable" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_data_table = _resolveComponent("n-data-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_n_data_table, {
      ref: "datatable",
      size: "small",
      remote: "",
      columns: _ctx.columns,
      bordered: true,
      data: _ctx.data,
      loading: _ctx.loading,
      pagination: _ctx.pagination,
      "min-height": 400,
      "max-height": 400,
      "row-props": (row) => ({class: 'dispatch-device-row', onClick: () => _ctx.onTableClick(row?.id)}),
      "onUpdate:sorter": _ctx.handleSorterChange,
      "onUpdate:filters": _ctx.handleFiltersChange,
      "onUpdate:page": _ctx.handlePageChange
    }, null, 8 /* PROPS */, ["columns", "data", "loading", "pagination", "row-props", "onUpdate:sorter", "onUpdate:filters", "onUpdate:page"])
  ]))
}